<template>
    <div class="flex flex-col gap-3">
      <template v-if="title !== 'Products'">
        <label class="text-lg font-medium md:font-semibold md:text-[28px]">{{ title }}</label>
        <div class="border rounded-md bg-white">
          <div
            v-for="index in 3"
            :key="'skeleton-' + index"
            v-if="loading"
            class="flex w-full gap-4 border-b last:border-b-0 p-3"
          >
            <div class="border rounded-sm h-10 w-12">
              <USkeleton class="w-full h-full" />
            </div>
            <div class="flex flex-col gap-2">
              <USkeleton class="h-4 w-24" />
              <USkeleton class="h-4 w-48" />
            </div>
          </div>
  
          <div
            v-for="(item, index) in items"
            :key="'item-' + index"
            class="flex w-full gap-4 border-b last:border-b-0 p-3 cursor-pointer"
            @click="item?.href && $emit('navigate', item.href)"
          >
            <div class="flex justify-center border rounded-sm h-10 w-12 flex-shrink-0">
              <NuxtImg :src="item.avatar" :alt="`Avatar for ${item.label}`" :title="`Image representing ${item.label}`" loading="lazy" class="object-contain" />
            </div>
            <div class="flex flex-col gap-0.5 tracking-wide">
              <p class="text-sm font-medium line-clamp-1">{{ item.label }}</p>
              <p class="text-xs font-normal text-gray-500 line-clamp-1" v-html="item.message"></p>
              <div class="flex gap-1 mt-1">
                <UBadge
                  v-for="(tag, i) in item.tags"
                  :key="i"
                  :label="tag"
                  :class="tag.toLowerCase() === 'non-deliverable'
                    ? 'bg-[#353535CC] text-white'
                    : 'bg-red-500 text-white'"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
      <label class="text-lg font-medium md:font-semibold md:text-[28px]">{{ title }}</label>
  
      <div class="grid grid-cols-2 md:grid-cols-6 gap-[24px] px-[16px] justify-items-center">
        <div
          v-for="index in 6"
          :key="'skeleton-' + index"
          v-if="loading"
          class="rounded-xl relative flex flex-col shadow-lg gap-y-3 cursor-pointer overflow-hidden bg-white"
        >
          <div class="flex items-center justify-center h-[140px]">
            <USkeleton class="w-full h-full" />
          </div>
          <div class="flex flex-col justify-between gap-y-2 px-[12px] pb-[12px]">
            <USkeleton class="h-4 w-20" />
            <USkeleton class="h-4 w-24" />
          </div>
        </div>
        <div
            v-for="(item, index) in items"
            :key="'product-' + index"
            class="bg-white rounded-xl flex flex-col shadow-lg cursor-pointer aspect-[160/140] w-full max-w-[180px] md:max-w-[220px]"
            style="scroll-snap-align: start;"
            @click="item?.href && $emit('navigate', item.href)"
          >
            <!-- Image section -->
            <div class="flex items-center justify-center h-[50%] mb-1">
              <NuxtImg
                :src="item.avatar"
                :alt="`Product image for ${item.label}`"
                :title="`Image of ${item.label} in search results`"
                class="object-contain w-full h-full"
                @error="setDefaultImage"
                quality="90" 
                loading="lazy"
              />
            </div>

            <div class="h-[20px] flex px-[12px]">
              <p
                v-if="item.message.isOutOfStock"
                v-html="item.message.isOutOfStock"
                class="text-sm text-red-500 font-semibold"
              ></p>
            </div>

            <!-- Product info -->
            <div class="flex flex-col justify-between gap-y-1 px-[12px]">
              <h3 class="font-medium text-sm line-clamp-1">{{ item.label }}</h3>
              <div class="flex items-center space-x-1">
                <p class="font-semibold text-base">₹{{ item.price }}</p>
                <span
                  v-if="item.max_price && item.price < item.max_price"
                  class="text-[#828282] font-normal text-sm line-through"
                >
                  ₹{{ item.max_price }}
                </span>
              </div>
            </div>
          </div>

      </div>
    </template>
  
  
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    title: { type: String, required: true },
    items: { type: Array, required: true },
    loading: { type: Boolean, required: true }
  });
  const runtimeConfig = useRuntimeConfig();

  const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultImage;
};
  </script>
  